
import $ from "jquery"


const INIT_DONE_CLASS_NAME = "js--collapsible--init-done"


const SELECTORS = {
  COLLAPSIBLE_CONTAINER:  ".collapsible",
  COLLAPSIBLE_TOGGLE:     ".collapsible-toggle",
}


function collapse_toggle($collapse_container_el: JQuery, $collapse_toggle_el: JQuery, event: Event) {
  const $collapse_toggle = $collapse_toggle_el
  const $collapse_container = $collapse_container_el

  // Don"t do anything when the toggle is freezed
  if ($collapse_toggle.data("freezed") != null) {
    return
  }

  // If it"s showing stuff by hover, clicking shouldn"t toggle again
  if ((event != null) &&
    (event.type === "click") &&
    !$collapse_container.hasClass("collapsed") &&
    $collapse_container.hasClass("uncollapsed-by-hover")) {
    return
  }

  if (event == null) {
    // if it"s simple clicking or function call, toggle directly
    setTimeout(() => {
      $collapse_toggle
      .toggleClass("collapsed")
      .find(".collapsible-content")
      .toggle()
    }, 0)
    return
  }

  // Must use `setTimeout` because otherwise click/touch events can goes to
  // the content directly, in rare cases where the content and the
  // toggle overlaps.
  if ((event.type === "mouseover") || (event.type === "mouseenter")) {
    setTimeout(() => {
      $collapse_toggle
      .removeClass("collapsed")
      .find(".collapsible-content")
      .show()

      // Add this class so that next time when it"s clicked, we know
      // the click shouldn"t change anything
      $collapse_container.addClass("uncollapsed-by-hover")
    }, 0)
  }
  else if ((event.type === "mouseout") || (event.type === "mouseleave")) {
    setTimeout(() => {
      $collapse_toggle
      .addClass("collapsed")
      .find(".collapsible-content")
      .hide()

      $collapse_container.removeClass("uncollapsed-by-hover")
    }, 0)
  }
}


// === Hide toggle target on start or after AJAX ===
function initOneElement(collapse_container_el: Element) {
  const $collapse_container_el = $(collapse_container_el)
  const $collapse_toggle_el = $collapse_container_el.find(`> ${SELECTORS.COLLAPSIBLE_TOGGLE}`)

  if ($collapse_container_el.hasClass(INIT_DONE_CLASS_NAME)) {
    return
  }
  else {
    $collapse_container_el.addClass(INIT_DONE_CLASS_NAME)
  }

  $collapse_toggle_el.on("click", (e: JQueryEventObject) => {
    collapse_toggle($collapse_container_el, $collapse_toggle_el, e)
  })

  if ($collapse_container_el.attr("data-js-enable-hover") === "true") {
    $(".collapsible[data-js-enable-hover='true']").hover(
      (e) => {
        collapse_toggle($collapse_container_el, $collapse_toggle_el, e)
      },
      (e) => {
        collapse_toggle($collapse_container_el, $collapse_toggle_el, e)
      }
    )
  }
}



const onLoad = () => {
  // On document ready
  $(SELECTORS.COLLAPSIBLE_CONTAINER).each((_idx, element) => {
    initOneElement(element)
  })

  // On AJAX success
  $(document).ajaxSuccess(() => {
    $(SELECTORS.COLLAPSIBLE_CONTAINER).each((_idx, element) => {
      initOneElement(element)
    })
  })
}


export default {
  onLoad: onLoad,
}
